import PieDefault from '../../lib/jin/svgchartlib/01_Charts/02_Pie/includes/primitives/Data'

export default PieDefault